import React from 'react';
import { Grid, Container} from '@mui/material';
import { Slide } from "react-awesome-reveal";

const Blog = ({data, parseContent}) => {
  return (
    <div id="Blog">
      <Container maxWidth="sm" sx={{my:2, py:2}} >
        {data?.title !== "" && <div className="section-title" style={{textAlign : "center"}}>
					<h2>{data ? data.title : "...loading"}</h2>
				</div>}
        {data ? data.cards.map( (item,i) =>(  
          <Grid key={`item-${i}`} sx={{pr:{ xs:1, md:"16px"}, mb : 4, flexDirection : i % 2 !== 0 ? "row-reverse" :"row" }} justifyContent="space-evenly" alignItems="center" container> 
          <Grid  item xs={11} md={5} sx={{mb:3}}>
            <Slide direction="left">
              <div className="inner_img_wrap" style={{ position:"relative", margin:"auto"}}>
                {item.media !== 1 ?  <img style={{width:"100%", height:"100%", objectFit:"cover"}} src={`${process.env.REACT_APP_PUBLIC_URL}/img/blog/${item.img}`} className="img-responsive" alt={item.img} />
                  : <video style={{width:"100%", height:"100%", objectFit:"cover", paddingBottom : "-8px"}} controls src={`${process.env.REACT_APP_PUBLIC_URL}/img/blog/${item.video}`} />}
                <span className="border_btm"/>
              </div>
            </Slide>
          </Grid>
          <Grid item xs={11} md={5} sx={{ paddingTop:"10px", pl:{xs:1, lg:3}, "& .section-title h2::after":{left : 0, marginLeft : 0}}}>
            {item?.title !== "" && <div className="section-title" >
              <Slide direction="right">
                <h3 style={{color : "#63799f"}}>{item.title}</h3>
              </Slide>
            </div>}
            <Slide  direction="right" delay={i * .1}>
            <div className="about-text"> 
              {parseContent(item.text)}
            </div>
            </Slide>    
          </Grid>
        </Grid>)) : "...loading!!"}
      </Container>
    </div>
  );
};
export default Blog;